import styled from 'styled-components';

export const ItemFamily = styled.button`
  display: inline-block;
  border-radius: 50%;
  background-image: url('${(props) => textToColor(props.color)}');
  background-size: 100%;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  filter: drop-shadow(#999 0.01rem);
  width: 22px;
  height: 22px;
  margin-top: 10px;
  margin-left: 5px;
  &:first-child {
    margin-left: 0;
  }
`;

export const ItemFamilyList = styled.div`
  display: inline-block;
`;

const textToColor = (textColor: string | undefined) => {
  const imagePath = `https://ikea.marat.qd.je/global/assets/customer-service/returns-claims/spareparts/images/dots/${textColor}.png`;
  return textColor ? imagePath : '';
};

export const StyledColorDot = styled.span`
  display: inline-block;
  position: absolute;
  background-image: url('${(props) => textToColor(props.color)}');
  background-size: 100%;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  margin-left: 70px;
`;

export const AvailableOptionsWrapper = styled.div`
  margin: 10px 0;
  width: 100%;
`;
